<template>
    <v-row>
        <Loader v-if="loader"></Loader>
        <v-col cols="12">
            <v-card flat>
                <v-card-text>
                    <v-col class="mx-auto" cols="12" sm="6">
                        <v-form ref="form" v-on:submit.prevent="saveGallery">
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field :rules="[requireRule]" v-model="name" hide-details
                                        label="نام" placeholder=" " dense outlined>
                                        <template #label>
                                            نام<span class="red--text"><strong> *</strong></span>
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field v-model.number="order" type="number" hide-details
                                        label="ترتیب نمایش" placeholder=" " dense outlined />
                                </v-col>
                                <v-col class="mt-3" cols="12">
                                    <BoxImages ref="fileManager" @uploadDone="getImgUrl" />
                                    <v-btn @click="$refs.fileManager.dialog = true" width="100%">
                                        انتخاب عکس
                                    </v-btn>
                                    <v-card>
                                        <v-img class="ma-3 text-center mx-auto" width="200" v-if="image" :src="$BaseUrl+image"></v-img>
                                    </v-card>
                                </v-col>
                                <v-col cols="12">
                                    <v-btn width="100%" height="40" class="white--text" depressed color="#02c9b7"
                                        type="submit">ذخیره</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-col>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import BoxImages from '../../components/Images.vue'
    export default {
        props: ['gallery_id'],
        data() {
            return {
                name: '',
                order: 0,
                loader: false,
                image: '',
            }
        },
        components: {
            BoxImages
        },
        created() {
            if (this.gallery_id) {
                this.getGallery()
            }
        },
        methods: {
            saveGallery() {
                var valid = this.$refs.form.validate();
                if (!valid)
                    return;
                this.loader = true
                var method = this.gallery_id ? 'put' : 'post'
                var url = this.gallery_id
                    ? '/admin/gallery/edit/' + this.gallery_id
                    : '/admin/gallery/add'
                this.request({
                        method: method,
                        url: url,
                        data: {
                            name: this.name,
                            image: this.image,
                            order: this.order || 0,
                        }
                    })
                    .then(() => {
                        this.$notify({
                            title: 'انجام شد',
                            text: 'با موفقیت انحام شد',
                            group: 'foo',
                            type: 'success',
                        });
                        this.$router.push({ name: 'list_gallery' })
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loader = false
                    })
            },
            getGallery() {
                this.loader = true
                this.request({
                        method: 'get',
                        url: '/admin/gallery/single/' + this.gallery_id,
                    })
                    .then((response) => {
                        this.name = response.data.name
                        this.image = response.data.image
                        this.order = response.data.order || 0
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loader = false
                    })
            },
            getImgUrl(e) {
                this.image = e
            },
        }
    }
</script>
